import React, {useState } from "react";
import Navbar from "../Navbar/Navbar";
import style from "./Doc.module.css";
function Doc() {

  const [value, setValue] = useState("");
  
  return (
    <>
      <Navbar />
      <div className={style.main}>
        <div className={style.head}>
          {" "}
          
          <textarea
            className={style.textarea}
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            placeholder=""
          />
        </div>
      </div>
    </>
  );
}

export default Doc;


